/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
const CSS = {
  actionBarContainer: "action-bar-container",
  container: "container",
  contentBottom: "content-bottom",
  contentTop: "content-top",
  header: "header",
  headerContainer: "header-container",
  headerContainerBorderEnd: "header-container--border-end",
  headingTextContent: "heading-text-content",
  heading: "heading",
  description: "description",
  headerContent: "header-content",
  headerActions: "header-actions",
  headerActionsEnd: "header-actions--end",
  headerActionsStart: "header-actions--start",
  icon: "icon",
  contentWrapper: "content-wrapper",
  fabContainer: "fab-container",
  footer: "footer",
  footerContent: "footer-content",
  footerStart: "footer-start",
  footerEnd: "footer-end",
  headerSlottedContent: "header--slotted-content",
  headerNonSlottedContent: "header--non-slotted-content",
  menuAction: "menu-action"
};
const IDS = {
  close: "close",
  collapse: "collapse"
};
const ICONS = {
  close: "x",
  menu: "ellipsis",
  expand: "chevron-down",
  collapse: "chevron-up"
};
const SLOTS = {
  actionBar: "action-bar",
  alerts: "alerts",
  contentBottom: "content-bottom",
  contentTop: "content-top",
  headerActionsStart: "header-actions-start",
  headerActionsEnd: "header-actions-end",
  description: "description",
  heading: "heading",
  headerMenuActions: "header-menu-actions",
  headerContent: "header-content",
  fab: "fab",
  footer: "footer",
  footerEnd: "footer-end",
  footerStart: "footer-start"
};
export {
  CSS as C,
  ICONS as I,
  SLOTS as S,
  IDS as a
};
